module.exports = __webpack_public_path__ + "media/brands/cfmoto-8e1f3bc1.png";